<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input ttLabel="stockplace_name_to" [(ttModel)]="setting.stockplace_name_to" ttReadonly></tt-input>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListStockPlaceDelTimes"></tt-list>
</tt-page>


<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="stockplace_name_to" tt-model="vm.model.setting.stockplace_name_to" tt-change="vm.model.setting.stockplace_name_to = $value" tt-readonly="true"></tt-input>
    </tt-card>
    <tt-list class="col-xs-12 col-md-4 sp-0" list-items="vm.model.itemsListStockPlaceDelTimes" badge="" ltype="" design-var="s12t0"></tt-list>
</tt-page>-->
